import { EyeSlashIcon, FunnelIcon } from '@heroicons/react/20/solid';

import { DashboardFilterValues, dashboardFilterCount } from '../api/types';

// The Calendar "Show" pill. It now only TOGGLES the approved horizontal filter
// bar (see CalendarFilterBar) — the controls themselves live in that bar,
// beneath the Calendar control row.
//
// It used to own a narrow vertical popover anchored to itself, holding every
// dimension as one long scrollable checkbox list. That was a generic
// implementation chosen because the popover was unspecified; the approved Figma
// node (37673:100905) specifies the bar instead, so the popover is gone rather
// than kept alongside it (GRAVY-10305).
//
// Per the design the pill reads "Hide" while the bar is open. The active-filter
// count stays on the pill so a collapsed bar still says filters are in force.

type Props = {
  open: boolean;
  onToggle: () => void;
  value: DashboardFilterValues;
  withReasons?: boolean;
};

const ShowFilter = ({ open, onToggle, value, withReasons }: Props) => {
  const count = dashboardFilterCount(value, { withReasons });

  return (
    <button
      type="button"
      className="dashv2-showbtn dashv2-showbtn--compact"
      aria-expanded={open}
      aria-controls="dashv2-calendar-filters"
      onClick={onToggle}
    >
      {open ? <EyeSlashIcon /> : <FunnelIcon />}
      {/* Icon-only below 1440, per the design; hidden visually, not removed, so
          the button keeps announcing "Show"/"Hide". */}
      <span className="dashv2-showbtn-label">{open ? 'Hide' : 'Show'}</span>
      {count > 0 && <span className="dashv2-qfcount">{count}</span>}
    </button>
  );
};

export default ShowFilter;
